import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';
import { ensureCurrentUser } from '../../util/data';
import { getImprovedLocationText } from '../../util/misc';
import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false, currentUser, publicData, userHasViewAccess, scrambleWords } = props;

  const user = ensureCurrentUser(currentUser);
  const isUserPremium = user && user?.attributes?.profile?.metadata?.isPremium
  const isSellListing = publicData.listingType === 'sell';
  // const shouldBlurDetails = !isUserPremium && isSellListing || isSellListing && heading == 'Description' && userHasViewAccess == false;
  // const shouldBlurDetails = heading == 'Teaser description' && !user?.id?.uuid;
  const shouldBlurDetails = false;

  const isMemberOnly = (heading == 'Location' && isSellListing && !currentUser);
    // || (heading == 'Location preference' && !isSellListing && !currentUser);

  const textClass = showAsIngress ? css.ingress : css.text;
  const content = shouldBlurDetails ? scrambleWords(text) : richText(text, {
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const locationText = getImprovedLocationText(publicData);
  const isLocationRow = heading == 'Location' || heading == 'Location preference';

  const finalContent = isLocationRow ? locationText : content;

  return text ? (
    <section className={css.sectionText}>
      <div className={css.inlineContainer}>
        {heading ? (
          <Heading as="h2" rootClassName={css.sectionHeading}>
            {heading}:
          </Heading>
        ) : null}
        <p className={`${textClass} ${shouldBlurDetails ? css.blurredValue : ""}`}>
          {/* {isMemberOnly ? "MEMBERS ONLY" : finalContent} */}
          {finalContent}
        </p>
      </div>

    </section>
  ) : null;
};

export default SectionTextMaybe;
